import React, {useState, useEffect, useContext, useRef} from "react";
import qs from 'query-string'

import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import {Link as RouterLink} from "react-router-dom";
import {toast} from "react-toastify";
import {Formik, Form, Field} from "formik";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import usePlans from '../../hooks/usePlans';
import {i18n} from "../../translate/i18n";
import {FormControl} from "@material-ui/core";
import {FormControlLabel, Checkbox} from "@material-ui/core";
import {InputLabel, MenuItem, Select} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Helmet} from "react-helmet";

import {openApi} from "../../services/api";
import toastError from "../../errors/toastError";
import useSettings from "../../hooks/useSettings";
import ColorModeContext from "../../layout/themeContext";
import {getBackendUrl} from "../../config";
import clsx from "clsx";
import BRFlag from "../../assets/brazil.png";
import USFlag from "../../assets/unitedstates.png";
import ESFlag from "../../assets/esspain.png";
import ARFlag from "../../assets/arabe.png";
import parsePlanAmount from "../../utils/parsePlanAmount";
import {
  allowedPaymentMethods as getAllowedPaymentMethods,
  maxInstallmentCount as getMaxInstallmentCount,
} from "../../utils/planMetadata";

const languageOptions = [
    { value: "pt-BR", label: "Português", icon: BRFlag },
    { value: "en", label: "English", icon: USFlag },
    { value: "es", label: "Spanish", icon: ESFlag },
    { value: "ar", label: "عربي", icon: ARFlag },
];

const useStyles = makeStyles(theme => {
    const {mode} = theme;
    return ({
        root: {
            width: "100vw",
            height: "100vh",
            boxSizing: "border-box",
            overflow: "hidden",
            position: "relative",
            backgroundColor: theme.palette.background ? theme.palette.background.default : (theme.palette.type === "light" ? "#f5f5f5" : "#303030"),
            backgroundImage: "none",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
        },
        scrollWrapper: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            textAlign: "center",
            padding: "20px 0",
            boxSizing: "border-box",
            overflow: "auto",

            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
            },
        },
        containerSignup: {
            padding: "16px",
            width: "calc(100% - 32px)",
            zIndex: 10,
            maxWidth: "420px",
            margin: "0 auto",

            [theme.breakpoints.down("sm")]: {
                width: "calc(100% - 40px)",
                maxWidth: "90%",
            },

            [theme.breakpoints.down("xs")]: {
                width: "calc(100% - 32px)",
                maxWidth: "85%",
            },
        },
        paper: {
            backgroundColor: mode === "dark" ? "rgba(40, 40, 40, 0.97)" : "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            boxShadow: mode === "dark"
                ? `0 20px 40px rgba(0, 0, 0, 0.4), 0 1px 0 rgba(255, 255, 255, 0.05) inset, 0 0 0 1px rgba(255, 255, 255, 0.05)`
                : `0 20px 40px rgba(0, 0, 0, 0.1), 0 1px 0 rgba(255, 255, 255, 0.2) inset, 0 0 0 1px rgba(255, 255, 255, 0.1)`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "30px 25px",
            borderRadius: "20px",
            maxWidth: "420px",
            width: "100%",
            margin: "0 auto",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            animation: "$slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
            position: "relative",
            boxSizing: "border-box",

            [theme.breakpoints.down("sm")]: {
                animation: "$slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
                borderRadius: "16px",
                padding: "25px 20px",
                boxSizing: "border-box",
                width: "100%",
            },

            [theme.breakpoints.down("xs")]: {
                padding: "20px 15px",
                borderRadius: "14px",
                boxShadow: `0 15px 30px rgba(0, 0, 0, 0.12)`,
                boxSizing: "border-box",
                width: "100%",
            },
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.primary.main,
        },
        form: {
            width: "100%",
            marginTop: theme.spacing(3),
        },
        submit: {
            margin: theme.spacing(3, 0, 2),
            background: mode === "light"
                ? `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`
                : `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
            color: "white",
            borderRadius: "12px",
            padding: "12px 0",
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "none",
            boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
            border: "none",
            transition: "all 0.3s ease",
            "&:hover": {
                background: mode === "light"
                    ? `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.dark})`
                    : `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.dark})`,
                transform: "translateY(-2px)",
                boxShadow: `0 6px 20px ${theme.palette.primary.main}66`,
            },
            "&:active": {
                transform: "translateY(0)",
            },
        },
        "@keyframes slideInUp": {
            from: {
                opacity: 0,
                transform: "translateY(30px)",
            },
            to: {
                opacity: 1,
                transform: "translateY(0)",
            },
        },
        languageSelector: {
            position: "fixed",
            top: "20px",
            left: "20px",
            zIndex: 1000,
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            borderRadius: "12px",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            padding: "8px 12px",
        },
        languageDropdown: {
            display: "flex",
            alignItems: "center",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
            gap: "8px",
            transition: "opacity 0.3s ease",
            "&:hover": {
                opacity: 0.8,
            },
        },
        languageOptions: {
            position: "absolute",
            top: "100%",
            left: "0",
            marginTop: "8px",
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(20px)",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
            borderRadius: "12px",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            padding: "8px",
            zIndex: 1000,
            minWidth: "140px",
        },
        languageOption: {
            background: "none",
            border: "none",
            color: "#374151",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            width: "100%",
            padding: "8px 12px",
            textAlign: "left",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.2s ease",
            "&:hover": {
                background: "rgba(59, 130, 246, 0.1)",
                color: "#3b82f6",
            },
        },
        flagIcon: {
            width: 20,
            height: 15,
            borderRadius: 2,
        },
    })
});

const BaseSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, i18n.t("signup.validation.nameMin") || "Nome muito curto")
        .max(50, i18n.t("signup.validation.nameMax") || "Nome muito longo")
        .required(i18n.t("signup.validation.nameRequired") || "Nome é obrigatório"),
    companyName: Yup.string()
        .min(2, i18n.t("signup.validation.companyNameMin") || "Nome muito curto")
        .max(50, i18n.t("signup.validation.companyNameMax") || "Nome muito longo")
        .required(i18n.t("signup.validation.companyNameRequired") || "Nome da organização é obrigatório"),
    document: Yup.string()
        .required(i18n.t("signup.validation.documentRequired") || "CPF ou CNPJ é obrigatório"),
    password: Yup.string()
        .min(8, i18n.t("signup.validation.passwordMin") || "A senha deve ter pelo menos 8 caracteres")
        .max(50, i18n.t("signup.validation.passwordMax") || "Senha muito longa")
        .matches(/[A-Z]/, i18n.t("signup.validation.passwordUppercase") || "A senha deve conter pelo menos 1 letra maiúscula")
        .matches(/[0-9]/, i18n.t("signup.validation.passwordNumber") || "A senha deve conter pelo menos 1 número")
        .matches(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/, i18n.t("signup.validation.passwordSpecialChar") || "A senha deve conter pelo menos 1 caractere especial")
        .required(i18n.t("signup.validation.passwordRequired") || "Senha é obrigatória"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], i18n.t("signup.validation.passwordMatch") || "As senhas não coincidem")
        .required(i18n.t("signup.validation.confirmPasswordRequired") || "Confirme sua senha"),
    email: Yup.string()
        .test('email-valid', i18n.t("signup.validation.emailInvalid") || 'E-mail inválido', v => !!v && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()))
        .required(i18n.t("signup.validation.emailRequired") || "E-mail é obrigatório"),
    phone: Yup.string()
        .test('phone-valid', i18n.t("signup.validation.phoneInvalid") || 'Número de WhatsApp inválido', v => {
            if (!v) return false;
            const n = v.replace(/\D/g, '');
            return n.length >= 7 && n.length <= 15;
        })
        .required(i18n.t("signup.validation.phoneRequired") || "WhatsApp é obrigatório"),
});

const buildPaidFlowSchema = (maxInstallments) => BaseSchema.shape({
    planId: Yup.number()
        .required(i18n.t("signup.validation.planRequired") || "Selecione um plano"),
    paymentFlow: Yup.string()
        .oneOf(["PIX", "BOLETO", "CREDIT_CARD"], i18n.t("signup.validation.paymentRequired") || "Selecione uma forma de pagamento")
        .required(i18n.t("signup.validation.paymentRequired") || "Selecione uma forma de pagamento"),
    installmentCount: Yup.mixed()
        .test(
            "installments-required",
            i18n.t("signup.validation.installmentsRequired") || "Selecione o número de parcelas",
            function (value) {
                const { paymentFlow } = this.parent;
                if (paymentFlow !== "CREDIT_CARD" || !maxInstallments) return true;
                const n = Number(value);
                return Number.isInteger(n) && n >= 1 && n <= maxInstallments;
            }
        ),
    renewalConsent: Yup.boolean()
        .oneOf([true], i18n.t("signup.validation.consentRequired") || "Você precisa aceitar a renovação automática para continuar")
        .required(i18n.t("signup.validation.consentRequired") || "Você precisa aceitar a renovação automática para continuar"),
});

const SignUp = () => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const {colorMode} = useContext(ColorModeContext);
    const {appLogoFavicon, appName, mode} = colorMode;
    const {getPlanList} = usePlans()
    const [loading, setLoading] = useState(true);
    const [validatingCnpj, setValidatingCnpj] = useState(false);
    const [lastValidatedDocument, setLastValidatedDocument] = useState("");
    const {getPublicSetting} = useSettings();

    const [backgroundLight, setBackgroundLight] = useState("");
    const [backgroundDark, setBackgroundDark] = useState("");

    const [open, setOpen] = useState(false);
    const ref = useRef();
    const [enabledLanguages, setEnabledLanguages] = useState(["pt-BR", "en"]);

    const params = qs.parse(window.location.search);
    const companyId = params.companyId || null;
    const urlPlanId = params.planId ? Number(params.planId) : null;
    const isPaidFlow = !!urlPlanId;

    const [selectedPlan, setSelectedPlan] = useState(null);

    const formatCurrency = (value) => {
        if (!Number.isFinite(value)) return "0,00";
        return value
            .toFixed(2)
            .replace(".", ",")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const allowedMethods = getAllowedPaymentMethods(selectedPlan);
    const maxInstallments = getMaxInstallmentCount(selectedPlan);
    const planAmount = selectedPlan ? parsePlanAmount(selectedPlan.amount) : 0;
    // For CC-only Semestral/Anual ("em até Nx") plans, plan.amount is the per-
    // monthly price at the maximum N, not the total. Mirrors backend
    // getPlanTotalValue() so UI pricing matches Asaas charges.
    const planTotalValue = maxInstallments
        ? Math.round(planAmount * maxInstallments * 100) / 100
        : planAmount;

    const [user, setUser] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone: "",
        companyId,
        companyName: "",
        document: "",
        planId: isPaidFlow ? urlPlanId : "",
        paymentFlow: "",
        installmentCount: "",
        renewalConsent: false,
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        getPublicSetting("userCreation")
            .then((data) => {
                if (data === "disabled") {
                    toast.error(i18n.t("signup.toasts.disabled"));
                    history.push("/login");
                }
            })
            .catch((error) => {
                console.log("Error reading setting", error);
            });

        getPublicSetting("enabledLanguages", companyId)
            .then((langs) => {
                let arr = ["pt-BR", "en"];
                try {
                    if (langs) arr = JSON.parse(langs);
                } catch {}
                setEnabledLanguages(arr);
            })
            .catch(() => {
                setEnabledLanguages(["pt-BR", "en"]);
            });

        getPublicSetting("appLogoBackgroundLight", companyId)
            .then((bgLight) => {
                if (bgLight) {
                    const backendUrl = getBackendUrl();
                    const fullUrl = backendUrl + "/public/" + bgLight;
                    console.log("Background light URL:", fullUrl);
                    setBackgroundLight(fullUrl);
                } else {
                    setBackgroundLight("");
                }
            })
            .catch((err) => {
                console.error("Erro ao carregar imagem de fundo clara:", err);
                setBackgroundLight("");
            });

        getPublicSetting("appLogoBackgroundDark", companyId)
            .then((bgDark) => {
                if (bgDark) {
                    const backendUrl = getBackendUrl();
                    const fullUrl = backendUrl + "/public/" + bgDark;
                    console.log("Background dark URL:", fullUrl);
                    setBackgroundDark(fullUrl);
                } else {
                    setBackgroundDark("");
                }
            })
            .catch((err) => {
                console.error("Erro ao carregar imagem de fundo escura:", err);
                setBackgroundDark("");
            });
    }, [history, companyId]);

    useEffect(() => {
        const fetchData = async () => {
            const planList = await getPlanList({listPublic: "false"});

            if (isPaidFlow) {
                const match = planList.find(p => p.id === urlPlanId);
                if (match) {
                    setSelectedPlan(match);
                    const methods = getAllowedPaymentMethods(match);
                    if (methods.length === 1) {
                        setUser(prev => ({ ...prev, paymentFlow: methods[0] }));
                    }
                } else {
                    toast.error(i18n.t("backendErrors.ERR_PLAN_NOT_FOUND"));
                }
            } else {
                const trialPlan = planList.find(p => p.trial);
                if (trialPlan) {
                    setUser(prev => ({ ...prev, planId: trialPlan.id }));
                }
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    const validateCpf = (cpf) => {
        const cleanCpf = cpf.replace(/\D/g, '');

        if (cleanCpf.length !== 11) return false;
        if (/^(\d)\1{10}$/.test(cleanCpf)) return false;

        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
        }
        let remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanCpf.charAt(9))) return false;

        sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
        }
        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanCpf.charAt(10))) return false;

        return true;
    };

    const validateCnpjLocal = (cnpj) => {
        const c = cnpj.replace(/\D/g, '');
        if (c.length !== 14) return false;
        if (/^(\d)\1{13}$/.test(c)) return false;

        const calc = (len) => {
            let sum = 0;
            let pos = len - 7;
            for (let i = len; i >= 1; i--) {
                sum += parseInt(c.charAt(len - i)) * pos--;
                if (pos < 2) pos = 9;
            }
            const res = sum % 11 < 2 ? 0 : 11 - (sum % 11);
            return res === parseInt(c.charAt(len));
        };

        return calc(12) && calc(13);
    };

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim().toLowerCase());
    };

    const formatPhone = (value) => {
        // Permite + no início e dígitos, espaços, hífens, parênteses — qualquer formato internacional
        const cleaned = value.replace(/[^\d\s\-()+]/g, '');
        return cleaned.slice(0, 20);
    };

    const validatePhone = (phone) => {
        const numbers = phone.replace(/\D/g, '');
        // Aceita de 7 (alguns países) até 15 dígitos (máx. padrão E.164)
        return numbers.length >= 7 && numbers.length <= 15;
    };

    const formatCpf = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 11);

        if (limitedNumbers.length <= 3) return limitedNumbers;
        if (limitedNumbers.length <= 6) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3)}`;
        if (limitedNumbers.length <= 9) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6)}`;
        return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6, 9)}-${limitedNumbers.slice(9)}`;
    };

    const formatCnpj = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 14);

        if (limitedNumbers.length <= 2) return limitedNumbers;
        if (limitedNumbers.length <= 5) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2)}`;
        if (limitedNumbers.length <= 8) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5)}`;
        if (limitedNumbers.length <= 12) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8)}`;
        return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8, 12)}-${limitedNumbers.slice(12)}`;
    };

    const detectDocumentType = (value) => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length <= 11) return 'cpf';
        return 'cnpj';
    };

    const formatDocument = (value) => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length <= 11) {
            return formatCpf(value);
        } else {
            return formatCnpj(value);
        }
    };

    const validateDocument = async (document, setFieldValue) => {
        const cleanDocument = document.replace(/\D/g, '');

        if (lastValidatedDocument === cleanDocument) return true;

        const documentType = detectDocumentType(document);

        if (documentType === 'cpf') {
            setLastValidatedDocument(cleanDocument);
            if (validateCpf(document)) {
                toast.success(i18n.t("signup.validation.cpfValid"));
                return true;
            } else {
                toast.error(i18n.t("signup.validation.cpfInvalid"));
                return false;
            }
        } else {
            if (cleanDocument.length !== 14) return false;

            // Valida dígitos verificadores localmente primeiro
            if (!validateCnpjLocal(cleanDocument)) {
                setLastValidatedDocument(cleanDocument);
                toast.error(i18n.t("signup.validation.cnpjInvalid"));
                return false;
            }

            // Busca nome na Receita Federal
            setValidatingCnpj(true);
            try {
                const response = await openApi.post("/auth/validate-cnpj", {cnpj: cleanDocument});
                const data = response.data;
                setValidatingCnpj(false);
                setLastValidatedDocument(cleanDocument);

                if (data.valid && data.data?.nome) {
                    setFieldValue('companyName', data.data.nome);
                    toast.success(i18n.t("signup.validation.cnpjValid"));
                    return true;
                } else {
                    toast.error(i18n.t("signup.validation.cnpjNotFound"));
                    return false;
                }
            } catch (error) {
                setValidatingCnpj(false);
                setLastValidatedDocument(cleanDocument);
                console.error("Erro ao validar CNPJ:", error);
                toast.warning(i18n.t("signup.validation.cnpjWarning"));
                return true;
            }
        }
    };

    const handleSignUp = async values => {
        try {
            const { confirmPassword, installmentCount, ...rest } = values;
            const payload = {
                ...rest,
                installmentCount:
                    values.paymentFlow === "CREDIT_CARD" && installmentCount !== ""
                        ? Number(installmentCount)
                        : undefined,
            };
            const response = await openApi.post("/auth/signup", payload);
            const checkoutUrl = response?.data?.checkoutUrl;
            if (checkoutUrl) {
                toast.success(i18n.t("signup.toasts.redirecting"));
                window.location.href = checkoutUrl;
                return;
            }
            toast.success(i18n.t("signup.toasts.success"));
            history.push("/login");
        } catch (err) {
            toastError(err);
        }
    };

    const current =
        languageOptions.find((opt) => opt.value === i18n.language) ||
        languageOptions[0];

    const handleSelect = (opt) => {
        i18n.changeLanguage(opt.value);
        localStorage.setItem("language", opt.value);
        setOpen(false);
        window.location.reload();
    };

    let finalBackground;

    const hasValidLightBg = backgroundLight && backgroundLight.trim() !== '';
    const hasValidDarkBg = backgroundDark && backgroundDark.trim() !== '';

    if (mode === "light") {
        if (hasValidLightBg) {
            finalBackground = `url(${backgroundLight})`;
        } else {
            finalBackground = theme.palette.background ? theme.palette.background.default : "#f5f5f5";
        }
    } else {
        if (hasValidDarkBg) {
            finalBackground = `url(${backgroundDark})`;
        } else {
            finalBackground = theme.palette.background ? theme.palette.background.default : "#303030";
        }
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{appName || "GoLiveZap - Cadastro"}</title>
                <link rel="icon" href={appLogoFavicon || "/default-favicon.ico"}/>
            </Helmet>

            <div
                className={classes.root}
                style={{
                    backgroundImage: typeof finalBackground === "string" && finalBackground.includes("url(")
                        ? finalBackground
                        : "none"
                }}
            >
              <div className={classes.scrollWrapper}>
                {/* Seletor de idioma */}
                <div
                    ref={ref}
                    className={classes.languageSelector}
                >
                    <button
                        onClick={() => setOpen((o) => !o)}
                        className={classes.languageDropdown}
                    >
                        <img
                            src={current.icon}
                            alt={current.label}
                            className={classes.flagIcon}
                        />
                        {current.label}
                        <span>▾</span>
                    </button>

                    {open && (
                        <div className={classes.languageOptions}>
                            {languageOptions
                                .filter((opt) => enabledLanguages.includes(opt.value))
                                .map((opt) => (
                                    <button
                                        key={opt.value}
                                        onClick={() => handleSelect(opt)}
                                        className={classes.languageOption}
                                    >
                                        <img
                                            src={opt.icon}
                                            alt={opt.label}
                                            className={classes.flagIcon}
                                        />
                                        {opt.label}
                                    </button>
                                ))}
                        </div>
                    )}
                </div>

                <Container
                    component="main"
                    maxWidth={false}
                    className={classes.containerSignup}
                >
                    <CssBaseline/>
                    <div className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <LockOutlinedIcon/>
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            {i18n.t("signup.title")}
                        </Typography>
                        <Formik
                            initialValues={user}
                            enableReinitialize={true}
                            validationSchema={isPaidFlow ? buildPaidFlowSchema(maxInstallments) : BaseSchema}
                            onSubmit={(values, actions) => {
                                setTimeout(() => {
                                    handleSignUp(values);
                                    actions.setSubmitting(false);
                                }, 400);
                            }}
                        >
                            {({touched, errors, isSubmitting, setFieldValue, values}) => (
                                <Form className={classes.form}>
                                    <Grid container spacing={2}>

                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="document"
                                                label={i18n.t("signup.form.document")}
                                                name="document"
                                                error={touched.document && Boolean(errors.document)}
                                                helperText={(touched.document && errors.document) || i18n.t("signup.form.documentHelper")}
                                                autoComplete="document"
                                                inputProps={{
                                                    maxLength: 18,
                                                    style: {textTransform: 'none'}
                                                }}
                                                InputProps={{
                                                    endAdornment: validatingCnpj && (
                                                        <CircularProgress size={20}/>
                                                    ),
                                                }}
                                                autoFocus
                                                onChange={(e) => {
                                                    let value = e.target.value;

                                                    const numbers = value.replace(/\D/g, '');

                                                    if (lastValidatedDocument && lastValidatedDocument !== numbers) {
                                                        setLastValidatedDocument("");
                                                    }

                                                    const formattedValue = formatDocument(value);
                                                    setFieldValue('document', formattedValue);

                                                    if (numbers.length === 11) {
                                                        validateDocument(formattedValue, setFieldValue);
                                                    } else if (numbers.length === 14) {
                                                        validateDocument(formattedValue, setFieldValue);
                                                    }
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="companyName"
                                                label={i18n.t("signup.form.company")}
                                                error={touched.companyName && Boolean(errors.companyName)}
                                                helperText={touched.companyName && errors.companyName}
                                                name="companyName"
                                                autoComplete="companyName"
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                autoComplete="name"
                                                name="name"
                                                error={touched.name && Boolean(errors.name)}
                                                helperText={touched.name && errors.name}
                                                variant="outlined"
                                                fullWidth
                                                id="name"
                                                label={i18n.t("signup.form.name")}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="email"
                                                label={i18n.t("signup.form.email")}
                                                name="email"
                                                error={touched.email && Boolean(errors.email)}
                                                helperText={touched.email && errors.email}
                                                autoComplete="email"
                                                inputProps={{style: {textTransform: 'lowercase'}}}
                                                onChange={(e) => {
                                                    const value = e.target.value.toLowerCase();
                                                    setFieldValue('email', value);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                name="password"
                                                error={touched.password && Boolean(errors.password)}
                                                helperText={
                                                    (touched.password && errors.password) ||
                                                    i18n.t("signup.form.passwordRequirements")
                                                }
                                                label={i18n.t("signup.form.password")}
                                                type={showPassword ? "text" : "password"}
                                                id="password"
                                                autoComplete="new-password"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => setShowPassword((v) => !v)}
                                                                edge="end"
                                                                style={{ color: "#6b7280" }}
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                name="confirmPassword"
                                                error={touched.confirmPassword && Boolean(errors.confirmPassword)}
                                                helperText={touched.confirmPassword && errors.confirmPassword}
                                                label={i18n.t("signup.form.confirmPassword")}
                                                type={showConfirmPassword ? "text" : "password"}
                                                id="confirmPassword"
                                                autoComplete="new-password"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle confirm password visibility"
                                                                onClick={() => setShowConfirmPassword((v) => !v)}
                                                                edge="end"
                                                                style={{ color: "#6b7280" }}
                                                            >
                                                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="phone"
                                                label={i18n.t("signup.form.phone")}
                                                name="phone"
                                                autoComplete="phone"
                                                error={touched.phone && Boolean(errors.phone)}
                                                helperText={(touched.phone && errors.phone) || i18n.t("signup.form.phoneHelper")}
                                                inputProps={{maxLength: 20}}
                                                onChange={(e) => {
                                                    const formatted = formatPhone(e.target.value);
                                                    setFieldValue('phone', formatted);
                                                }}
                                            />
                                        </Grid>

                                        {isPaidFlow && selectedPlan && (
                                        <Grid item xs={12}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                label={i18n.t("signup.form.plan")}
                                                value={selectedPlan.name}
                                                InputProps={{ readOnly: true }}
                                            />
                                            <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4 }}>
                                                {i18n.t("signup.form.planTotal", { value: formatCurrency(planTotalValue) })}
                                            </Typography>
                                        </Grid>
                                        )}

                                        {isPaidFlow && (
                                        <Grid item xs={12}>
                                            <InputLabel htmlFor="payment-flow-selection">{i18n.t("signup.form.paymentMethod")}</InputLabel>
                                            <Field
                                                as={Select}
                                                variant="outlined"
                                                fullWidth
                                                id="payment-flow-selection"
                                                label={i18n.t("signup.form.paymentMethod")}
                                                name="paymentFlow"
                                                required
                                                error={touched.paymentFlow && Boolean(errors.paymentFlow)}
                                                onChange={(e) => {
                                                    setFieldValue("paymentFlow", e.target.value);
                                                    // Clear installments when switching payment method.
                                                    setFieldValue("installmentCount", "");
                                                }}
                                                MenuProps={{
                                                    getContentAnchorEl: null,
                                                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                    transformOrigin: { vertical: "top", horizontal: "left" },
                                                    PaperProps: {
                                                        style: { maxHeight: 400 }
                                                    }
                                                }}
                                            >
                                                {allowedMethods.includes("PIX") && <MenuItem value="PIX">{i18n.t("signup.paymentOptions.pix")}</MenuItem>}
                                                {allowedMethods.includes("BOLETO") && <MenuItem value="BOLETO">{i18n.t("signup.paymentOptions.boleto")}</MenuItem>}
                                                {allowedMethods.includes("CREDIT_CARD") && <MenuItem value="CREDIT_CARD">{i18n.t("signup.paymentOptions.card")}</MenuItem>}
                                            </Field>
                                        </Grid>
                                        )}

                                        {isPaidFlow && maxInstallments && values.paymentFlow === "CREDIT_CARD" && (
                                        <Grid item xs={12}>
                                            <InputLabel htmlFor="installment-count-selection">{i18n.t("signup.form.installments")}</InputLabel>
                                            <Field
                                                as={Select}
                                                variant="outlined"
                                                fullWidth
                                                id="installment-count-selection"
                                                name="installmentCount"
                                                required
                                                error={touched.installmentCount && Boolean(errors.installmentCount)}
                                                MenuProps={{
                                                    getContentAnchorEl: null,
                                                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                    transformOrigin: { vertical: "top", horizontal: "left" },
                                                    PaperProps: {
                                                        style: { maxHeight: 400 }
                                                    }
                                                }}
                                            >
                                                {Array.from({ length: maxInstallments }, (_, i) => {
                                                    const count = i + 1;
                                                    const perInstallment = planTotalValue / count;
                                                    const key = count === 1 ? "signup.form.installmentsOptionSingle" : "signup.form.installmentsOption";
                                                    return (
                                                        <MenuItem key={count} value={count}>
                                                            {i18n.t(key, { count, value: formatCurrency(perInstallment) })}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Field>
                                            <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4 }}>
                                                {i18n.t("signup.form.installmentsHelper", { max: maxInstallments })}
                                            </Typography>
                                            {touched.installmentCount && errors.installmentCount && (
                                                <Typography variant="caption" color="error" style={{ display: "block", marginTop: 4 }}>
                                                    {errors.installmentCount}
                                                </Typography>
                                            )}
                                        </Grid>
                                        )}

                                        {isPaidFlow && (
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                style={{ alignItems: "flex-start", marginLeft: 0, marginRight: 0 }}
                                                control={
                                                    <Field
                                                        as={Checkbox}
                                                        name="renewalConsent"
                                                        color="primary"
                                                        type="checkbox"
                                                        style={{ paddingTop: 7, paddingBottom: 7 }}
                                                    />
                                                }
                                                label={
                                                    <Typography variant="body2" color="textSecondary" style={{ lineHeight: 1.4 }}>
                                                        {i18n.t("signup.consent.label")}
                                                    </Typography>
                                                }
                                            />
                                            {touched.renewalConsent && errors.renewalConsent && (
                                                <Typography variant="caption" color="error" style={{display: "block", marginLeft: 32, marginTop: 4}}>
                                                    {errors.renewalConsent}
                                                </Typography>
                                            )}
                                        </Grid>
                                        )}

                                    </Grid>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        disabled={loading || validatingCnpj || isSubmitting}
                                    >
                                        {i18n.t("signup.buttons.submit")}
                                    </Button>
                                    <Grid container>
                                        <Grid item>
                                            <Link
                                                href="#"
                                                variant="body2"
                                                component={RouterLink}
                                                to="/login"
                                            >
                                                {i18n.t("signup.buttons.login")}
                                            </Link>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    <Box mt={5}>{/* <Copyright /> */}</Box>
                </Container>
              </div>
            </div>
        </React.Fragment>
    );
};

export default SignUp;
